import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { LoginStatus } from '../../../../core/models/auth.models';
import { PhoneInputComponent } from '../../../../shared/components/phone-input/phone-input.component';
import { getPhoneValidationError, resolvePhoneCredentials } from '../../../../shared/utils/phone.utils';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('phoneInput') phoneInput?: PhoneInputComponent;

  loading = false;
  hidePassword = true;
  errorMessage = '';

  readonly form = this.fb.group({
    phone: ['', [Validators.required]],
    password: ['', [Validators.required, Validators.minLength(4)]],
    rememberMe: [false],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.redirectAfterLogin();
    }
  }

  submit(): void {
    this.errorMessage = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { phone, password, rememberMe } = this.form.getRawValue();
    const { username, dialCode } = resolvePhoneCredentials(phone!, this.phoneInput?.getInstance());

    this.loading = true;
    this.authService.login(username, password!, !!rememberMe, dialCode).then((result) => {
      this.loading = false;

      if (result.status === 'SUCCESS') {
        this.redirectAfterLogin();
        return;
      }

      this.errorMessage = this.getErrorMessage(result.status);
    });
  }

  getPhoneError(): string | null {
    const control = this.form.controls.phone;
    if (!control.touched || control.valid) {
      return null;
    }

    if (control.hasError('required')) {
      return 'Le téléphone est requis';
    }

    return getPhoneValidationError(control.errors?.['invalidPhone']);
  }

  private redirectAfterLogin(): void {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/accueil';
    this.router.navigateByUrl(returnUrl);
  }

  private getErrorMessage(status: LoginStatus): string {
    switch (status) {
      case 'UNAUTHORIZED':
        return 'Identifiants incorrects. Vérifiez votre téléphone et votre mot de passe.';
      case 'DISABLED_ACCOUNT':
        return 'Votre compte est désactivé. Contactez le support Saarvie.';
      case 'TIMEOUT':
        return 'Impossible de joindre le serveur d’authentification. Réessayez dans un instant.';
      default:
        return 'Une erreur est survenue lors de la connexion.';
    }
  }
}
